import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import SoftwareArticles from 'components/Software/Home_Automation/IntroHomeAutomation';
import YoutubeVideoCard from 'components/Software/Home_Automation/YoutubeVideoCard';
import NavButtons from 'components/Software/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  SoftwareArticles,
  YoutubeVideoCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};